import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'lib-heading-header',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './heading-header.component.html'
})
export class HeadingHeaderComponent {}
